import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { checkContactInfo, getContactById, updateContact } from '../../../../services/contactService';
import { fetchContactRoutine, saveContactInfoRoutine, setContactInfoErrorRoutine } from '../../routines';

function* getContactByIdRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getContactById, payload);

    yield put(fetchContactRoutine.success(response));
  } catch {
    yield put(fetchContactRoutine.failure());
  }
}

function* watchGetContactByIdRequest() {
  yield takeEvery(fetchContactRoutine.TRIGGER, getContactByIdRequest);
}

function* updateContactRequest({ payload }: Routine<any>) {
  try {
    const { id, ...rest } = payload;
    const { isValid } = yield call(
      checkContactInfo,
      { excludeIds: [id], email: rest.email, phoneNumber: rest.phoneNumber }
    );
    if (isValid) {
      yield call(updateContact, payload);
      yield put(saveContactInfoRoutine.success(rest));
    } else {
      yield put(setContactInfoErrorRoutine.trigger(true));
    }
  } catch (error) {
    yield put(saveContactInfoRoutine.failure(payload));
  }
}

function* watchUpdateContactRequest() {
  yield takeEvery(saveContactInfoRoutine.TRIGGER, updateContactRequest);
}

export default function* contactSaga() {
  yield all([
    watchGetContactByIdRequest(),
    watchUpdateContactRequest()
  ]);
}
